import { render, staticRenderFns } from "./HeaderSegment.vue?vue&type=template&id=53c898d7&scoped=true&"
import script from "./HeaderSegment.vue?vue&type=script&lang=js&"
export * from "./HeaderSegment.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSegment.vue?vue&type=style&index=0&id=53c898d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c898d7",
  null
  
)

export default component.exports